import type { AuthorizationModuleClientDeps, AuthorizationModuleClientType } from '../contracts/client';

export async function load(
  implementation: 'core',
  deps: AuthorizationModuleClientDeps
): Promise<AuthorizationModuleClientType> {
  switch (implementation) {
    case 'core':
      return (await import('../implementations/core/src/client')).create(deps);
    default:
      throw new Error(`Unknown authorization client implementation: ${implementation || '<missing>'}`);
  }
}
